
import ModalRegisterProfileAfiliado from "../DialogRegisterProfile/ModalRegisterProfileAfiliado";
import { useResizeScreen } from "../../hooks/useResizeScreen";

const ModalProfile = ({ isOpen, setOpen }) => {

    const { screen } = useResizeScreen();

    return <>
    { isOpen ?
        <ModalRegisterProfileAfiliado
            style={{margin:"center"}}
            title={
                <div style={{ marginTop:  screen.sWidth < 768 ? "0px" :'20px', fontSize:"19px" }}>
                    No se encuentra registrado como Medico
                </div>
            }            description={
                <div style={{ textAlign: 'center',marginBottom:"40px", marginTop:"-15px" }}>
                    ¿Desea registrarse?
                </div>
            }
            open={isOpen}
            onClose={setOpen}
            modalconfirm={true}
            modalLogout={true}
            
        />
        : ""}
</>;
};

export default ModalProfile;